import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const TestimonialCard = ({ t }) => (
  <div className="rounded-[20px] border border-neutral-200 bg-white p-7 hover:shadow-lg transition-shadow duration-300">
    <div className="flex items-center gap-1 text-[#f4b400]">
      {Array.from({ length: t.rating }).map((_, i) => (
        <Star key={i} size={15} fill="currentColor" strokeWidth={0} />
      ))}
    </div>
    <Quote size={22} className="mt-5 text-neutral-300" />
    <p className="mt-3 text-[15px] leading-relaxed text-neutral-700">&ldquo;{t.text}&rdquo;</p>
    <p className="mt-6 text-[15px] font-semibold text-neutral-900">{t.name}</p>
  </div>
);

const Testimonials = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="max-w-2xl">
          <span className="text-[12px] font-semibold tracking-[0.2em] text-neutral-500 uppercase">Google Reviews</span>
          <h2 className="mt-3 text-[36px] lg:text-[48px] leading-[1.02] font-bold tracking-tight text-neutral-900">
            Patients choose care that feels <span className="font-serif-italic font-normal">clear, kind, and effective.</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t) => (
            <TestimonialCard key={t.id} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
